import React, { memo } from 'react';
import { Note } from "../store/types";
import { NoteComponent } from "./NoteComponent";
import { timePosToY, PRELOAD_LEN } from './lane';
import { EditContainer } from '../store/EditContainer';

interface Props {
  notes: Note[];
  selectedTrack: number;
  panelScrollY: number;
  panelHeight: number;
}

export const Notes: React.FC<Props> = memo(props => {
  const { verticalZoom } = EditContainer.useContainer();
  return (
    <div>
      {props.notes.filter(note => {
        const y = timePosToY(note.timePos, verticalZoom);
        return props.panelScrollY - props.panelHeight * PRELOAD_LEN < y &&
          y <= props.panelScrollY + props.panelHeight * (1 + PRELOAD_LEN);
      }).map(note =>
        <NoteComponent
          key={note.id}
          note={note}
          trackSelected={note.track === props.selectedTrack}
        />
      )}
    </div>
  );
});
